import { ADMIN_CONTENT_SETTINGS_GRADES_MAP } from "@/admin/constants/AdminContentSettingsGroupGradesMap";

const generateContentSettingsGroupName = (group) => {
  const blockOrShowText = group.block_teacher_view
    ? "Block"
    : "Show with advisory";
  if (group.grade_minimum === group.grade_maximum) {
    return `${ADMIN_CONTENT_SETTINGS_GRADES_MAP[group.grade_minimum]}\u00A0 \u00A0${blockOrShowText}`;
  }
  return `${ADMIN_CONTENT_SETTINGS_GRADES_MAP[group.grade_minimum]} - ${ADMIN_CONTENT_SETTINGS_GRADES_MAP[group.grade_maximum]}\u00A0 \u00A0${blockOrShowText}`;
};

export default generateContentSettingsGroupName;
